import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import styles from './ExploreNullState.module.scss';

type ExploreNullStateProps = {
  buttons: ComponentProps<typeof Button>[];
  className?: string;
  description?: ReactNode;
  title: ReactNode;
};

const ExploreNullState = ({ buttons, className, description, title }: ExploreNullStateProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.text}>
        <Typography component="div" variant="heading300">
          {title}
        </Typography>
        {description && (
          <Typography color="secondary" component="div" variant="text200">
            {description}
          </Typography>
        )}
      </div>
      <div className={styles.buttons}>
        {buttons.map((buttonProps, index) => {
          const keyLabel = buttonProps.title ?? (typeof buttonProps.text === 'string' ? buttonProps.text : '');
          return <Button key={`${keyLabel}-${index}`} {...buttonProps} />;
        })}
      </div>
    </div>
  );
};

export default ExploreNullState;
